// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select2-container--default .select2-selection--multiple[data-v-5154851c]{border:none;background:transparent}
`, "",{"version":3,"sources":["webpack://./components/product-tags.vue"],"names":[],"mappings":"AACA,0EACI,WAAA,CACA,sBAAA","sourcesContent":["\n.select2-container--default .select2-selection--multiple {\n    border: none;\n    background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
